const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.06,262.72s-12-5.12-12-30.12-2-52.85-28-74.94-47-7.55-87-.61-42-32.91-126-28.74-102,54.5-106,88.79,33,48.58,16,74.83-35,31.57-28,65.06,30,52.79,81,54,80-46.88,110-49.08,46,49.62,115,40.54S472.06,325.56,429.06,262.72Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.06,262.72s-12-5.12-12-30.12-2-52.85-28-74.94-47-7.55-87-.61-42-32.91-126-28.74-102,54.5-106,88.79,33,48.58,16,74.83-35,31.57-28,65.06,30,52.79,81,54,80-46.88,110-49.08,46,49.62,115,40.54S472.06,325.56,429.06,262.72Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340,311.15h80.38a4.29,4.29,0,0,1,4.29,4.29v52.28a0,0,0,0,1,0,0h-89a0,0,0,0,1,0,0V315.44A4.29,4.29,0,0,1,340,311.15Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.56,315.44H415.8a4.29,4.29,0,0,1,4.29,4.29v48.75a0,0,0,0,1,0,0H340.26a0,0,0,0,1,0,0V319.74A4.3,4.3,0,0,1,344.56,315.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.9,372.3H332.5a7.62,7.62,0,0,1-7.62-7.62H431.52A7.62,7.62,0,0,1,423.9,372.3Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.35,311.15h80.38a4.29,4.29,0,0,1,4.29,4.29v52.28a0,0,0,0,1,0,0h-89a0,0,0,0,1,0,0V315.44A4.29,4.29,0,0,1,217.35,311.15Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.92,315.44h71.24a4.29,4.29,0,0,1,4.29,4.29v48.75a0,0,0,0,1,0,0H217.63a0,0,0,0,1,0,0V319.74A4.29,4.29,0,0,1,221.92,315.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.27,372.3H209.86a7.62,7.62,0,0,1-7.62-7.62H308.88A7.62,7.62,0,0,1,301.27,372.3Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-3--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.66,311.15H172a4.29,4.29,0,0,1,4.29,4.29v52.28a0,0,0,0,1,0,0h-89a0,0,0,0,1,0,0V315.44A4.29,4.29,0,0,1,91.66,311.15Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.23,315.44h71.24a4.29,4.29,0,0,1,4.29,4.29v48.75a0,0,0,0,1,0,0H91.94a0,0,0,0,1,0,0V319.74A4.3,4.3,0,0,1,96.23,315.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.58,372.3H84.17a7.62,7.62,0,0,1-7.61-7.62H183.2A7.62,7.62,0,0,1,175.58,372.3Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.88 358.68 115.88 358.68 115.88 321.18 135.54 321.18 143.88 328.82 143.88 358.68",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.54 321.18 135.54 328.82 143.88 328.82 135.54 321.18",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393,270.08a56.82,56.82,0,0,0-30.3-46.7,56.81,56.81,0,0,0-93.87-61.67A56.83,56.83,0,0,0,161.2,197.28c-1.75-.16-3.51-.26-5.3-.26a56.82,56.82,0,0,0-54.45,73.06Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.82,181l2.62-1.2-.56-3.15-2.89-.22a12.37,12.37,0,0,0-1.45-2.74l1.5-2.52-2.26-2.26-2.54,1.51a12.57,12.57,0,0,0-4.85-2l-.73-2.9h-3.2l-.73,2.92a12.72,12.72,0,0,0-2.88.91l-2.28-2L202,169.24l1.08,2.82a13,13,0,0,0-1.84,2.39l-3-.31-1.09,3,2.49,1.69a13.48,13.48,0,0,0-.18,2.12c0,.3,0,.6,0,.9l-2.62,1.46.82,3.09,3,0a12.85,12.85,0,0,0,1.63,2.59L201,191.61l2.45,2.06,2.37-1.7a12.45,12.45,0,0,0,2.86,1.2l.47,2.87,3.19.27,1-2.71a12.45,12.45,0,0,0,3.06-.66l2,2,2.77-1.6-.76-2.75a12.63,12.63,0,0,0,2.12-2.32l2.82.52,1.35-2.89-2.21-1.83A12.66,12.66,0,0,0,224.82,181Zm-4.73-.06a8,8,0,1,1-8-8A8,8,0,0,1,220.09,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.41,228.34l2.62-1.2-.55-3.14-2.89-.23a13.3,13.3,0,0,0-1.45-2.74l1.49-2.52-2.26-2.26-2.54,1.51a12.66,12.66,0,0,0-4.85-2l-.73-2.9h-3.19l-.74,2.92a12.48,12.48,0,0,0-2.87.91l-2.29-2-2.62,1.83,1.08,2.83a12.15,12.15,0,0,0-1.83,2.38l-3-.31-1.1,3,2.49,1.69a13.48,13.48,0,0,0-.17,2.12c0,.31,0,.6,0,.9l-2.62,1.46.83,3.09,3,0a12.85,12.85,0,0,0,1.63,2.59L291.55,239,294,241l2.37-1.7a12.94,12.94,0,0,0,2.86,1.21l.48,2.86,3.18.28,1-2.71a12.36,12.36,0,0,0,3.06-.67l2,2,2.77-1.6-.76-2.75a13,13,0,0,0,2.13-2.32l2.81.52,1.35-2.9L315,231.45A12.33,12.33,0,0,0,315.41,228.34Zm-4.73-.06a8,8,0,1,1-8-8A8,8,0,0,1,310.68,228.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.56,253.38v-32.5a9.5,9.5,0,0,1,9.5-9.5h68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.39,203.55h15a9.67,9.67,0,0,1,9.67,9.67v34.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,119.26v38.07a3.1,3.1,0,0,0,3.1,3.1h12.15a3.1,3.1,0,0,1,3.1,3.1v8.94H210a7.21,7.21,0,0,0-7.21,7.22v51.4a7.21,7.21,0,0,0,7.21,7.22h94.7a7.21,7.21,0,0,0,7.21-7.22v-51.4a7.21,7.21,0,0,0-7.21-7.22H271.31v-8.94a3.1,3.1,0,0,1,3.1-3.1h12.16a3.09,3.09,0,0,0,3.09-3.1V120.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.05,104.88s20.33,2.49,23.95,24.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.8 128.74 244.56 136.88 248.73 127.83 238.8 128.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.55,104.88s-21.8,4.09-24.27,41.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.41 145.06 255.06 153.88 260.37 145.45 250.41 145.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.05,88.38s20.33,2.49,23.95,24.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.8 112.24 248.56 120.38 252.73 111.33 242.8 112.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.55,104.88s-20.32,2.49-23.94,24.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.88 127.83 272.06 136.88 277.81 128.74 267.88 127.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,180.87H267.06v-10h-20v10H214.71a5.91,5.91,0,0,0-5.91,5.92V224.7a5.91,5.91,0,0,0,5.91,5.91H300a5.92,5.92,0,0,0,5.92-5.91V186.79A5.92,5.92,0,0,0,300,180.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.18,
    y1: 188.8,
    x2: 229.04,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.18,
    y1: 194.88,
    x2: 248.66,
    y2: 194.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.09,
    y1: 194.88,
    x2: 260.3,
    y2: 194.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262.9,
    y1: 194.88,
    x2: 278.36,
    y2: 194.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.67,
    y1: 188.8,
    x2: 253.53,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.93,
    y1: 188.8,
    x2: 297.99,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.93,
    y1: 194.88,
    x2: 297.99,
    y2: 194.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.34,
    y1: 188.8,
    x2: 238.24,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.09,
    y1: 188.8,
    x2: 261.99,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.6,
    y1: 188.8,
    x2: 268.98,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.55,
    y1: 188.8,
    x2: 277.45,
    y2: 188.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.99,
    y1: 200.44,
    x2: 285.14,
    y2: 200.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.99,
    y1: 206.52,
    x2: 265.51,
    y2: 206.52,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.08,
    y1: 206.52,
    x2: 253.87,
    y2: 206.52,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.27,
    y1: 206.52,
    x2: 235.81,
    y2: 206.52,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.5,
    y1: 200.44,
    x2: 260.65,
    y2: 200.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.25,
    y1: 200.44,
    x2: 216.18,
    y2: 200.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.25,
    y1: 206.52,
    x2: 216.18,
    y2: 206.52,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.84,
    y1: 200.44,
    x2: 275.93,
    y2: 200.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.08,
    y1: 200.44,
    x2: 252.18,
    y2: 200.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.57,
    y1: 200.44,
    x2: 245.19,
    y2: 200.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.63,
    y1: 200.44,
    x2: 236.72,
    y2: 200.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.99,
    y1: 211.9,
    x2: 285.14,
    y2: 211.9,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.18,
    y1: 217.98,
    x2: 248.66,
    y2: 217.98,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.09,
    y1: 217.98,
    x2: 260.3,
    y2: 217.98,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 262.9,
    y1: 217.98,
    x2: 278.36,
    y2: 217.98,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.5,
    y1: 211.9,
    x2: 260.65,
    y2: 211.9,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.25,
    y1: 211.9,
    x2: 216.18,
    y2: 211.9,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.93,
    y1: 217.98,
    x2: 297.99,
    y2: 217.98,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.84,
    y1: 211.9,
    x2: 275.93,
    y2: 211.9,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.08,
    y1: 211.9,
    x2: 252.18,
    y2: 211.9,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.57,
    y1: 211.9,
    x2: 245.19,
    y2: 211.9,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.63,
    y1: 211.9,
    x2: 236.72,
    y2: 211.9,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.99,
    y1: 223.37,
    x2: 285.14,
    y2: 223.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.5,
    y1: 223.37,
    x2: 260.65,
    y2: 223.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.25,
    y1: 223.37,
    x2: 216.18,
    y2: 223.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.84,
    y1: 223.37,
    x2: 275.93,
    y2: 223.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.08,
    y1: 223.37,
    x2: 252.18,
    y2: 223.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.57,
    y1: 223.37,
    x2: 245.19,
    y2: 223.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.63,
    y1: 223.37,
    x2: 236.72,
    y2: 223.37,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.65,240.22l3.74-1.7L190.6,234l-4.12-.32a17.94,17.94,0,0,0-2.06-3.9l2.12-3.59L183.32,223l-3.61,2.15a18.12,18.12,0,0,0-6.9-2.82l-1-4.12h-4.55l-1.05,4.15a17.74,17.74,0,0,0-4.09,1.3l-3.25-2.81-3.73,2.6,1.53,4a18.77,18.77,0,0,0-2.61,3.39l-4.28-.44-1.56,4.27,3.55,2.41a17.67,17.67,0,0,0-.26,3c0,.43,0,.86.05,1.28l-3.73,2.08,1.18,4.4,4.22-.06a18.22,18.22,0,0,0,2.32,3.69l-1.82,3.79,3.48,2.92,3.38-2.42a17.65,17.65,0,0,0,4.07,1.72l.68,4.08,4.53.39,1.37-3.85a18.13,18.13,0,0,0,4.36-1l2.86,2.91,3.94-2.28-1.08-3.92a17.87,17.87,0,0,0,3-3.3l4,.74,1.92-4.12-3.14-2.59A18,18,0,0,0,187.65,240.22Zm-6.73-.08a11.36,11.36,0,1,1-11.36-11.36A11.36,11.36,0,0,1,180.92,240.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.25,270.08h6.8a11.35,11.35,0,0,1,22.37,0H152l-.74-4.18-4.11-.32a18,18,0,0,0-2.07-3.9l2.13-3.59L144,254.87,140.38,257a18,18,0,0,0-6.9-2.82l-1-4.12h-4.55l-1,4.15a18,18,0,0,0-4.1,1.3l-3.25-2.82-3.72,2.61,1.53,4a17.9,17.9,0,0,0-2.61,3.39l-4.29-.44-1.55,4.27,3.54,2.41C112.33,269.34,112.29,269.71,112.25,270.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.72,
    y: 252.22,
    width: 20,
    height: 8,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.39,
    y: 240.74,
    width: 21.33,
    height: 29.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "321.06 252.75 299.06 252.75 299.06 244.81 257.55 244.81 257.55 252.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.72,
    y1: 264.22,
    x2: 273.72,
    y2: 264.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.39,
    y: 254.6,
    width: 14.67,
    height: 15.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.39,
    y: 249.55,
    width: 39.33,
    height: 42.67,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.72,
    y: 249.55,
    width: 32.67,
    height: 42.67,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.05,
    cy: 252.27,
    r: 2.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.64,
    cy: 244.81,
    r: 2.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.39,
    y: 240.74,
    width: 28.67,
    height: 29.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.39,
    y: 249.55,
    width: 39.33,
    height: 6.89,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.07 251.97 333.45 251.97 333.45 247.99 319.64 255.97 333.45 263.95 333.45 259.97 344.07 259.97 344.07 251.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.85 261.76 252.85 272.37 248.87 272.37 256.85 286.19 264.83 272.37 260.85 272.37 260.85 261.76 252.85 261.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.9,
    y1: 207.37,
    x2: 342.9,
    y2: 223.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.41 222.45 342.9 226.77 345.4 222.45 340.41 222.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.39,186.09a12.3,12.3,0,0,1,7.51,11.34v3.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.41 200.08 342.9 204.4 345.4 200.08 340.41 200.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.88,
    y1: 185.12,
    x2: 327.01,
    y2: 185.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.28 187.62 330.6 185.13 326.28 182.63 326.28 187.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.8,
    cy: 384.06,
    r: 7.8,
    transform: "translate(-246.71 183.16) rotate(-45.74)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.13,384.06a2.34,2.34,0,1,0-2.33,2.34A2.33,2.33,0,0,0,96.13,384.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.01,
    cy: 384.06,
    r: 7.8,
    transform: "translate(-230.86 210.79) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.35,384.06A2.34,2.34,0,1,0,139,386.4,2.34,2.34,0,0,0,141.35,384.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.23,
    cy: 384.06,
    r: 7.8,
    transform: "translate(-83.57 52.81) rotate(-13.33)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.57,384.06a2.34,2.34,0,1,0-2.34,2.34A2.34,2.34,0,0,0,186.57,384.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.45,
    cy: 384.06,
    r: 7.8,
    transform: "translate(-82.36 63.24) rotate(-13.33)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.79,384.06a2.34,2.34,0,1,0-2.34,2.34A2.34,2.34,0,0,0,231.79,384.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.66,
    cy: 384.06,
    r: 7.8,
    transform: "translate(-58.11 49.09) rotate(-9.24)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,384.06a2.34,2.34,0,1,0-2.34,2.34A2.34,2.34,0,0,0,277,384.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.88,
    cy: 384.06,
    r: 7.8,
    transform: "translate(-177.88 338.68) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.22,384.06a2.34,2.34,0,1,0-2.34,2.34A2.34,2.34,0,0,0,322.22,384.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.1,
    cy: 384.06,
    r: 7.8,
    transform: "translate(-164.64 370.65) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44,384.06a2.34,2.34,0,1,0-2.34,2.34A2.34,2.34,0,0,0,367.44,384.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.31,
    cy: 384.06,
    r: 7.8,
    transform: "translate(-69.49 91.41) rotate(-11.73)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.65,384.06a2.34,2.34,0,1,0-2.33,2.34A2.33,2.33,0,0,0,412.65,384.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.06,
    y: 373.01,
    width: 366,
    height: 6,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.06,
    y1: 378.85,
    x2: 77.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.06,
    y1: 378.85,
    x2: 91.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.06,
    y1: 378.85,
    x2: 105.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.06,
    y1: 378.85,
    x2: 119.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.06,
    y1: 378.85,
    x2: 133.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.06,
    y1: 378.85,
    x2: 147.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.06,
    y1: 378.85,
    x2: 161.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.06,
    y1: 378.85,
    x2: 175.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.06,
    y1: 378.85,
    x2: 189.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.06,
    y1: 378.85,
    x2: 203.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.06,
    y1: 373.02,
    x2: 217.06,
    y2: 378.85,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.06,
    y1: 378.85,
    x2: 231.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.06,
    y1: 378.85,
    x2: 245.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.06,
    y1: 378.85,
    x2: 259.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.06,
    y1: 378.85,
    x2: 273.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.06,
    y1: 378.85,
    x2: 287.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.06,
    y1: 378.85,
    x2: 301.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.06,
    y1: 378.85,
    x2: 315.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.06,
    y1: 378.85,
    x2: 329.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.06,
    y1: 378.85,
    x2: 343.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.06,
    y1: 378.85,
    x2: 357.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.06,
    y1: 378.85,
    x2: 371.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.06,
    y1: 378.85,
    x2: 385.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.06,
    y1: 378.85,
    x2: 399.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.06,
    y1: 378.85,
    x2: 413.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.06,
    y1: 378.85,
    x2: 427.06,
    y2: 373.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.06,
    y: 390.01,
    width: 366,
    height: 6,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.06,
    y1: 395.85,
    x2: 77.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.06,
    y1: 395.85,
    x2: 91.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.06,
    y1: 395.85,
    x2: 105.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.06,
    y1: 395.85,
    x2: 119.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.06,
    y1: 395.85,
    x2: 133.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.06,
    y1: 395.85,
    x2: 147.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.06,
    y1: 395.85,
    x2: 161.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.06,
    y1: 395.85,
    x2: 175.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.06,
    y1: 395.85,
    x2: 189.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.06,
    y1: 395.85,
    x2: 203.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.06,
    y1: 395.85,
    x2: 217.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.06,
    y1: 395.85,
    x2: 231.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.06,
    y1: 395.85,
    x2: 245.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.06,
    y1: 395.85,
    x2: 259.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.06,
    y1: 395.85,
    x2: 273.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.06,
    y1: 395.85,
    x2: 287.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.06,
    y1: 395.85,
    x2: 301.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.06,
    y1: 395.85,
    x2: 315.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.06,
    y1: 395.85,
    x2: 329.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.06,
    y1: 395.85,
    x2: 343.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.06,
    y1: 395.85,
    x2: 357.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.06,
    y1: 395.85,
    x2: 371.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.06,
    y1: 395.85,
    x2: 385.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.06,
    y1: 395.85,
    x2: 399.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.06,
    y1: 395.85,
    x2: 413.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.06,
    y1: 395.85,
    x2: 427.06,
    y2: 390.02,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--File--inject-66"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "272.57 326.15 244.57 326.15 244.57 288.64 264.23 288.64 272.57 296.28 272.57 326.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.23 288.64 264.23 296.28 272.57 296.28 264.23 288.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.55ae5c6d7b8e7e237e28ec794239a417.svg";
export { ForwardRef as ReactComponent };